import { render, staticRenderFns } from "./MenuNavigationComponent.vue?vue&type=template&id=229cd58a&"
import script from "./MenuNavigationComponent.vue?vue&type=script&lang=js&"
export * from "./MenuNavigationComponent.vue?vue&type=script&lang=js&"
import style0 from "./MenuNavigationComponent.vue?vue&type=style&index=0&id=229cd58a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports